import React, {useState} from 'react';
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import SmartContract from "../contracts/BeeTestContract1155.json";


const MintButton = ({accounts, provider}) => {
    const [price, setPrice] = useState();
    const mint = async () => {
        Web3EthContract.setProvider(provider);
        try {
            const networkId = await provider.request({
                method: "net_version",
            });
            if (networkId == 4) {
                let web3 = new Web3(provider);
                const SmartContractObj = new Web3EthContract(
                    SmartContract.abi,
                    "0x0076494bde971d5Ee47515Df62eF36636c279245"
                );
                SmartContractObj.methods.price().call(function(err, res){
                    setPrice(res);
                    console.log(res)
                });
                SmartContractObj.methods
                .mint(1)
                .send({
                    gasLimit: "285000",
                    to: "0x0076494bde971d5Ee47515Df62eF36636c279245",
                    from: accounts[0],
                    value: web3.utils.toWei((price/10**18 * 1).toString(), "ether"),
                })
                .once("error", (err) => {
                    console.log(err);
                })
                .then((receipt) => {
                    alert("Minted!")
                });
            }
        } catch (error) {console.log(error)}

    }

    async function handleClick () {
            console.log(provider.networkVersion)
            if(provider.networkVersion!= 4) alert("Please select Rinkeby network")
            else mint();
    }

    return (
        <button onClick={()=> handleClick ()} disabled={!accounts}>Mint</button>
      );
}

export default MintButton;